import React, { InputHTMLAttributes } from 'react';
import './Input.style.scss';

export interface IProps extends InputHTMLAttributes<HTMLInputElement> {
  handleOnChange: (value: string) => void;
  refInput?: React.RefObject<HTMLInputElement>;
}

const Input = (props: IProps) => {
  const {
    type,
    className,
    value,
    handleOnChange,
    refInput,
    ...remainingProps
  } = props;

  return (
    <input
      ref={refInput}
      type={type}
      className={`input ${className ? className : ''}`}
      value={value}
      onChange={(event) => handleOnChange(event.currentTarget.value)}
      {...remainingProps}
    />
  );
};

export default Input;
